import { connect } from 'react-redux';
import { compose } from 'redux';

import UpdateGroupVersions from './../components/UpdateGroupVersions';
import { groupEntityActions, groupEntitySelectors } from 'containers/App/modules/entities/groups/groupEntity.slice';
import { modalActions } from 'containers/ModalRoot/modules/modal.slice';
import { dbSelectors } from 'containers/App/modules/entities/entities.selectors';
import entitySchemas from 'containers/App/modules/api/schema';


const mapStateToProps = (state, ownProps) => {
	const editedGroupId = ownProps.groupId; //groupSelectors.selectEditedGroupId(state);
  const group = dbSelectors.selectEntitiesDenormalized(entitySchemas.group,  editedGroupId)(state);
  
	return {
		isFetchVersionsLoading: groupEntitySelectors.selectFetchVersionsPending(state),
    group,
    potentialVersions: groupEntitySelectors.selectGroupPotentialVersions(state),
	}
};

const withConnect = connect(mapStateToProps, { ...groupEntityActions, ...modalActions });

export default compose(
	withConnect
)(UpdateGroupVersions);